import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../../store/store"; // Adjust this based on your store
import { setUser } from "../../store/userSlice";
import { Box, Button, Typography } from "@mui/material";
import { useGetUserAttributesQuery } from "../../store/userApi";
import LoadingPage from "../../common/LoadingPage";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(
    (state: RootState) => state.user.user !== null,
  );

  const { data: user, isLoading, error } = useGetUserAttributesQuery();

  useEffect(() => {
    if (user) {
      dispatch(setUser(user));
    }
  }, [user, dispatch]);

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!isAuthenticated && error) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  if (false) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        marginTop={"2.5%"}
        textAlign="center"
      >
        <Typography variant="h4" gutterBottom>
          Your account is not verified
        </Typography>
        <Button variant="contained" color="secondary" size="large">
          {"Click here to send verification email"}
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
